import Qs from 'qs'; 
import { parse, HTMLElement } from 'next/dist/compiled/node-html-parser'

export default function stringifySearch(search) {
  return Qs.stringify(search, {
    arrayFormat: 'brackets', 
    encode: true 
  })
}



export function loadConfig(service) {
  let page_layout_config = {}
  let configurator_settings = {}
  let stylesheet;
  let favicon; 
  let cart_enabled;
  let resource_display;
  let use_map_on_agency_locator_page;
  let inspiration_display;
  let configurator_enabled;
  try {
    page_layout_config = JSON.parse(service.config.page_layout)
    configurator_settings = JSON.parse(service.config.configurator_settings)
  }
  catch(e){
  } 

  stylesheet = (service.config && service.config.client_stylesheet) ? service.config.client_stylesheet : null 
  favicon = (service.config && service.config.favicon) ? service.config.favicon : null 
  cart_enabled = service?.config?.cart_enabled === 'true' ? true : false ;
  use_map_on_agency_locator_page = service?.config?.use_map_on_agency_locator_page === 'true' ? true : false ;
  configurator_enabled = service?.config?.configurator_enabled === 'true' ? true : false ;

  resource_display = service?.config?.resource_display || 'list_view';
  inspiration_display = service?.config?.inspiration_display || 'application_photos_only';


  return {
    page_layout: page_layout_config,
    hash_id: service.config?.hash_id || '', 
    configurator_settings: configurator_settings,
    stylesheet: stylesheet, 
    favicon: favicon, 
    cart_enabled: cart_enabled,
    configurator_enabled: configurator_enabled,
    use_map_on_agency_locator_page: use_map_on_agency_locator_page, 
    attribute_filters_position: service?.config?.attribute_filters_position  || 'All Open',
    resource_display: resource_display,
    enable_asset_multiple_link_copying_modal: service?.config?.enable_asset_multiple_link_copying_modal || null, 
    enable_asset_multiple_link_download_modal: service?.config?.enable_asset_multiple_link_download_modal || null,
    enable_infinite_scroll_on_product_pages: service?.config?.enable_infinite_scroll_on_product_pages || null,
    inspiration_display: inspiration_display
  }
}

export function getProductLink(product) {
  if (product.child_brand_link) {
    return  product.child_brand_link  
  }
  else {
  return `/lex-cms/product/${product.slug }`  
  }
}
export function getGalleryLink(gallery) {
  return `/lex-cms/inspiration/gallery/${gallery.id}`  
 }

export function getAppPhotoLink(app_photo, query) {
  if (query) {
    let search = stringifySearch(query )
    return `/lex-cms/inspiration/application_photo/${app_photo.id}?${search}`  
  }
  else {
   return `/lex-cms/inspiration/application_photo/${app_photo.id}`  
  
  }
 }

export function appPhotoRouting(app_photo, gallery_id) {
  let q = {} 
  if (gallery_id) {
    q.gallery_id = gallery_id
  }
  return {href: {pathname: '/inspiration/application_photo/[show]', query: {show: app_photo.id, ...q}  },  
    as: getAppPhotoLink(app_photo, q) }
}

export function productRouting(product) {
   return {href: {pathname: '/product/[slug]', query: {slug: product.slug}  },  as: getProductLink(product) }
}

export function galleryRouting(gallery) {
  return {href: {pathname: '/inspiration/gallery/[show]', query: {show: gallery.id}  },  
    as: getGalleryLink(gallery) }
}
export function galleriesRouting(path, scroll) {
  let [index, q] = path.split('?')  
  if (q) {
    q =  Qs.parse(q,
        {
          arrayFormat: 'brackets',
          encode: true
        }
      );
  }
  else {
    q = {}
  }

  if (scroll) {
    q.scroll = scroll
  }
  return {href: {pathname: '/inspiration/galleries/[index]', query: {index: index, ...q, clientNavigation: 1}  },  
    as: path }
}
export function appPhotosRouting(path, scroll) {
  let [index, q] = path.split('?')  
  if (q) {
    q =  Qs.parse(q,
        {
          arrayFormat: 'brackets',
          encode: true
        }
      );
  }
  else {
    q = {}
  }

  if (scroll) {
    q.scroll = scroll
  }
  return {href: {pathname: '/inspiration/application_photos/[index]', query: {index: index, ...q, clientNavigation: 1}  },  
    as: path }
}


export function configuratorHost( ) {
 return process.env.NODE_ENV  == 'development' ? 'http://localhost:3003' : 'https://configurator.lighting.exchange'
}

export function is_mobile(userAgent) {
  return userAgent ? /iPad|Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(userAgent): false;
}

export function extractIdFromSlug(params, key='slug') {
  let id = null;
  if (params && params[key]) {
    let matches = params[key].match(/^(?<id>\d+)-/);
    if (matches) {
      id = matches.groups.id;
    }
  }
  return id
}

export function  downloadLink(d){ 
  let token;
  let man_id;
  let u;
  try {
    u = new URL(d.url)
    if (/^\/downloads\/m-\d+\//.test(u.pathname) ){
      token = u.pathname.split('/')[3]
      man_id = u.pathname.split('/')[2] 
    }
    else {
      token = u.pathname.split('/').pop()
    }
  }
  catch(e) {
    console.log(e)
    return ''; 
  }
  return `/lex-cms/download_referral/${man_id}/${token}/${d?.slug_name}`;
}

export function getActiveNavItem(page_layout) {
  if (page_layout?.header_html && typeof window === 'undefined'&&
    page_layout?.nav_item_selector && page_layout?.nav_active_class
  ) {
    let html = parse(page_layout?.header_html); 
    let currentPath = page_layout.currentPath 
    let navItems = html.querySelectorAll(`${page_layout.nav_item_selector}`)
    let fuzzyPathSelector = `a[href^="${currentPath.replace(/\?.*/,'')}"]`
    let absolutePathSelector = `a[href="${currentPath}"]`




    if (navItems) {
       //scrub any other instances
       let itemsToScrub = html.querySelectorAll(`${page_layout.nav_item_selector}.${page_layout?.nav_active_class}`)

      itemsToScrub.forEach((d, i) => {
        let node = d;
        node.classList.remove(`${page_layout?.nav_active_class}`)
        html.exchangeChild(d, node);
       })
      let theItems=  navItems.filter((elem) => {
        return  elem.querySelector(fuzzyPathSelector);
      })
      theItems?.forEach((item, i) => {
        let newNode  = item
        if (i === 0 || item.querySelector(absolutePathSelector ) ) {
        
        let classNames = Array.from(newNode.classList?._set).join(' ');
        newNode.setAttribute('class', `${classNames} ${page_layout?.nav_active_class}` )
        html.exchangeChild(item, newNode)
        }
      })

    }

    return  html.toString();
  }

}



export const pluralize = (val, word, plural = word + 's') => {
  const _pluralize = (num, word, plural = word + 's') =>
    [1, -1].includes(Number(num)) ? word : plural;
  if (typeof val === 'object') return (num, word) => _pluralize(num, word, val[word]);
  return _pluralize(val, word, plural);
}


export const inspirationInflections =  (resource, count) => {
  let list = {
    galleries: 'gallery', 
    photos: 'photo'
  }
  if (count === 1) {
    return list[resource]
  }
  else {
    return resource
  }
}
